import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'

class Sidebar extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  render() {
    return (
      <nav class="sidebar sidebar-offcanvas" id="sidebar">
        <ul class="nav">
          <li class="nav-item">
              <Link to="/" className='nav-link'>
                <i class="icon-grid menu-icon"></i> 
                <span className="menu-title">Dashboard</span>
              </Link>
          </li>
          <li class="nav-item">
              <Link to="/category" className='nav-link'>
                <i class="icon-layout menu-icon"></i> 
                <span className="menu-title">Categories</span>
              </Link>
          </li>
          <li class="nav-item">
              <Link to="/tags" className='nav-link'>
                <i class="icon-columns menu-icon"></i> 
                <span className="menu-title">Tags</span>
              </Link>
          </li>
          <li class="nav-item">
              <Link to="/post" className='nav-link'>
                <i className="icon-paper menu-icon"> </i>
                <span className="menu-title">Posts</span>
              </Link>
          </li>
          <li class="nav-item">
              <Link to="/media" className='nav-link'>
                <i className="icon-contract menu-icon"> </i>
                <span className="menu-title">Media</span>
              </Link>
          </li>
          <li class="nav-item">
              <Link to="/user" className='nav-link'>
                <i className="icon-head menu-icon"> </i>
                <span className="menu-title">User</span>
              </Link>
          </li>
          <li class="nav-item">
              <Link to="/subject" className='nav-link'>
                <i className="fa fa-paper-plane menu-icon"></i>
                <span className="menu-title">Int Subject</span>
              </Link>
          </li>
          <li class="nav-item">
              <Link to="/question" className='nav-link'>
                <i className="fa fa-question menu-icon"></i>
                <span className="menu-title">Int Questions</span>
              </Link>
          </li>
          <li class="nav-item">
              <Link to="/pages" className='nav-link'>
                <i className="fa fa-file menu-icon"></i>
                <span className="menu-title">Pages</span>
              </Link>
          </li>
          <li class="nav-item">
              <Link to="/sitemap" className='nav-link'>
                <i className="fa fa-sitemap menu-icon"></i>
                <span className="menu-title">Sitemaps</span>
              </Link>
          </li>
        </ul>
      </nav>
    )
  }
}

export default Sidebar